var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncrement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95693 3.58819V9.16683H5.04026V3.58819L2.58178 6.04668L1.93359 5.3985L5.49859 1.8335L9.0636 5.3985L8.41543 6.04668L5.95693 3.58819Z",
    fill: "#47B881"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrement);
export default __webpack_public_path__ + "static/media/increment.5815f4cd9d8f160ef62f9eba53e1c977.svg";
export { ForwardRef as ReactComponent };